import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/python';
import comment from '../../snippets/comment';
import {locales} from '../sampleLocations';
import {CreateShellCommand} from '../../../components/left-col';

const createIntent = (country, reader) => {
  if (reader === 'wpe') {
    const currency = locales[country].currency;
    const pmTypes =
      country === 'CA'
        ? `['card_present', 'interac_present']`
        : `['card_present']`;
    return `
{+create-intent}
@app.route('/create_payment_intent', methods=['POST'])
def secret():
  data = json.loads(request.data)

  # For Terminal payments, the 'payment_method_types' parameter must include
  # 'card_present' and the 'capture_method' must be set to 'manual'
  {span response create-intent}intent{/span} = stripe.PaymentIntent.create(
    amount=data['amount'],
    currency='${currency}',
    payment_method_types=${pmTypes},
    capture_method='manual'
  )
  return jsonify(client_secret=intent.client_secret)
{/create-intent}
`;
  }
};

const createLocation = (country) => {
  const location = locales[country].location;
  const state = location.address.state
    ? `
      state: '${location.address.state}',`
    : '';
  return `
def create_location():
{+create-location}
  location = stripe.terminal.Location.create(
    display_name='${location.displayName}',
    address={
      line1: '${location.address.line1}',
      city: '${location.address.city}',${state}
      country: '${location.address.country}',
      postal_code: '${location.address.postalCode}',
    },
  )
{/create-location}

  return location
`;
};

const homeRoute = `
@app.route('/')
def index():
  return render_template('index.html')
`;

export const steps = {
  setup,
  'create-location': {},
  'connection-token-endpoint': {},
  'create-intent': {},
  'capture-intent-endpoint': {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.server.python.run-server.body',
        defaultMessage:
          'Run your Python server and go to <a>localhost:4242</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({
  keys,
  merchant,
  reader,
  platform,
  country,
}) => `#! /usr/bin/env python3.6

# Python 3.6 or newer required.

import json
import os
{+setup}
import stripe
${comment && comment(merchant, '#')}
stripe.api_key = '${keys.secret}'
{/setup}

from flask import Flask, jsonify, ${
  platform === 'web' ? 'render_template, ' : ''
}request


app = Flask(__name__, static_folder='public',
            static_url_path='', template_folder='public')
${createLocation(country)}
# The ConnectionToken's secret lets you connect to any Stripe Terminal reader
# and take payments with your Stripe account.
# Be sure to authenticate the endpoint for creating connection tokens.
{+connection-token-endpoint}
@app.route('/connection_token', methods=['POST'])
def token():
  {span response connection-token-endpoint}connection_token{/span} = stripe.terminal.ConnectionToken.create()
  return jsonify(secret=connection_token.secret)
{/connection-token-endpoint}
${createIntent(country, reader)}
{+capture-intent-endpoint}
@app.route('/capture_payment_intent', methods=['POST'])
def capture():
  data = json.loads(request.data)
  {span response capture-intent-endpoint}intent{/span} = stripe.PaymentIntent.capture(
    data['id']
  )
  return intent
{/capture-intent-endpoint}
${platform === 'web' ? homeRoute : ''}
if __name__ == '__main__':
    app.run()`;
